import React from 'react';
import { createPortal } from 'react-dom';
import BackButton from '../buttons/BackButton';
import './GlobalNavButtons.css';

interface GlobalNavButtonsProps {
  /** Показывать ли кнопку назад */
  showBack: boolean;
  /** Обработчик нажатия кнопки назад */
  onBack: () => void;
  /** Прозрачный стиль кнопки назад */
  backTransparent?: boolean;
  /** Показывать ли кнопку меню */
  showMenu: boolean;
  /** Обработчик нажатия кнопки меню */
  onMenu: () => void;
  /** Прозрачный стиль кнопки меню */
  menuTransparent?: boolean;
}

/**
 * Глобальные навигационные кнопки, которые всегда находятся в одних точках экрана.
 * Рендерятся через портал поверх всего контента.
 */
const GlobalNavButtons: React.FC<GlobalNavButtonsProps> = ({
  showBack,
  onBack,
  backTransparent = false,
  showMenu,
  onMenu,
  menuTransparent = false
}) => {
  if (!showBack && !showMenu) return null;

  return createPortal(
    <>
      {/* Кнопка назад - слева */}
      {showBack && (
        <div className="global-nav-button global-nav-button--left">
          <BackButton
            variant="arrow"
            size="medium"
            onClick={onBack}
            transparent={backTransparent}
          />
        </div>
      )}
      
      {/* Кнопка меню - справа */}
      {showMenu && (
        <div className="global-nav-button global-nav-button--right">
          <BackButton
            variant="menu"
            size="medium"
            onClick={onMenu}
            transparent={menuTransparent}
          />
        </div>
      )}
    </>,
    document.body
  );
};

export default GlobalNavButtons;
